<template>
  <router-link :to="url" class="gallery-banner" :class="{ compact }">
    <component :is="bannerComponent(resource)" :resource="resource"></component>
    <span class="caption" v-if="caption">{{ caption }}</span>
  </router-link>
</template>

<script>
import StaticBanner from './banners/StaticBanner.vue';
import GalleryBanner from '../structure/Resources/GalleryBanner';
import { stateAwarePath } from '../support';
import RendersBannerComponent from '@mixins/RendersBannerComponent';

export default {
  mixins: [RendersBannerComponent],

  props: {
    banner: {
      type: GalleryBanner,
      required: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    caption() {
      return this.banner.caption();
    },

    resource() {
      return this.banner.resource();
    },

    url() {
      return stateAwarePath(this.resource);
    },
  },

  components: {
    StaticBanner,
  },
};
</script>

<style lang="scss" scoped>
.gallery-banner {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-end;
  justify-content: flex-start;
  margin: 0 0.5rem 2rem;
  text-decoration: none;

  &.compact {
    margin: 0;
  }
}

.caption {
  text-align: right;
  padding: 0.5rem 1rem;
  font-size: 1.1rem;
  color: #666;
  font-style: italic;

  @include dark {
    color: #999;
  }
}
</style>
